import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-gray-950 text-white">
        <span className="text-sm tracking-[0.3em] uppercase animate-pulse">Loading</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) {
    return (
      <div className="min-h-screen grid place-items-center bg-gray-950 text-white text-center px-6">
        <div>
          <p className="text-lg font-heading font-semibold">Not authorized</p>
          <p className="text-sm text-gray-400 mt-2">
            Your account ({user.email}) does not have admin access.
          </p>
        </div>
      </div>
    );
  }
  return children;
}
